import React from 'react';
import { MoreHoriz, ExpandLess } from '@mui/icons-material';
import { useTitleToggle } from 'lib/hooks/useTitleToggle';
import { reactToString } from 'lib/filters';
import { ParsedUrlQuery } from 'querystring';

interface TitleWithToggleProps {
  fullTitle: React.ReactNode;
  exportTitle: string;
  previewTitle?: React.ReactNode;
  hasMinimumCriteria?: boolean;
  query?: ParsedUrlQuery;
  className?: string;
}

export function TitleWithToggle({
  fullTitle,
  exportTitle,
  previewTitle,
  hasMinimumCriteria = true,
  query,
  className = '',
}: TitleWithToggleProps) {
  // Convert React elements to string for accurate length calculation
  const titleAsString = React.isValidElement(fullTitle)
    ? reactToString(fullTitle as any)
    : (fullTitle?.toString() || exportTitle);

  const {
    showFullTitle,
    titleNeedsToggle,
    displayTitle,
    toggleTitle,
    titleRef,
  } = useTitleToggle({
    fullTitle,
    exportTitle: titleAsString,
    previewTitle,
    hasMinimumCriteria,
    query,
  });

  return (
    <div
      ref={titleRef}
      className={className}
    >
      {displayTitle}
      {titleNeedsToggle && (
        <button
          type="button"
          className="text-sm rounded-xl justify-center items-center border-2 border-teal px-1 m-1"
          onClick={toggleTitle}
        >
          {showFullTitle
            ? <ExpandLess fontSize="small" color="secondary" />
            : <MoreHoriz fontSize="small" color="secondary" />}
        </button>
      )}
    </div>
  );
}
